import { RUNTIME_SCHEMA_VERSION, type BuildIdentity } from './productionContracts';

const DEVELOPMENT_IDENTITY: BuildIdentity = Object.freeze({
  appVersion: __APP_VERSION__,
  appBuildHash: 'development',
  runtimeSchemaVersion: RUNTIME_SCHEMA_VERSION,
});

/** Build identity is generated after Vite hashes the canonical production output. */
export async function loadBuildIdentity(): Promise<BuildIdentity> {
  if (import.meta.env.DEV) return DEVELOPMENT_IDENTITY;
  try {
    const response = await fetch('/build-identity.json', { cache: 'no-cache' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const value = (await response.json()) as Partial<BuildIdentity>;
    if (
      value.appVersion !== __APP_VERSION__ ||
      typeof value.appBuildHash !== 'string' ||
      !/^[a-f0-9]{64}$/u.test(value.appBuildHash) ||
      value.runtimeSchemaVersion !== RUNTIME_SCHEMA_VERSION
    ) {
      throw new Error('invalid build identity');
    }
    return value as BuildIdentity;
  } catch (error) {
    console.error('[receipt] production build identity unavailable', error);
    throw error;
  }
}
